import * as React from "react";
import {Box, Table, TableBody, TableCell, TableHead, TableRow, Typography} from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import {documentNumberChip} from "./AccountingDocumentCells";

function amountOrDash(hasAmount, amount, color) {
    if (!hasAmount) {
        return <Typography variant="body2" color="text.disabled">—</Typography>;
    }
    return <Typography variant="body2" color={color} fontWeight={700}>{amount}</Typography>;
}

function documentCell(row) {
    if (row.isInitialBalance) {
        return '-';
    }
    return (
        <Box sx={{display: 'inline-flex', alignItems: 'center', gap: 0.5}}>
            {documentNumberChip(row.documentLabel)}
            {row.hasFile && <PictureAsPdfIcon fontSize="small" color="action"/>}
        </Box>
    );
}

function primaryRecordRow(row) {
    return (
        <TableRow key={`${row.date}-${row.type}-${row.documentLabel}`}>
            <TableCell>{row.date}</TableCell>
            <TableCell>{row.type}</TableCell>
            <TableCell>{documentCell(row)}</TableCell>
            <TableCell align="right">{amountOrDash(row.hasDebit, row.debit, 'error.main')}</TableCell>
            <TableCell align="right">{amountOrDash(row.hasCredit, row.credit, 'success.main')}</TableCell>
            <TableCell align="right">
                <Typography variant="body2" fontWeight={700}>{row.balance}</Typography>
            </TableCell>
        </TableRow>
    );
}

function PrimaryRecordPanel({rows}) {
    return (
        <Table size="small">
            <TableHead>
                <TableRow>
                    <TableCell>Fecha</TableCell>
                    <TableCell>Tipo</TableCell>
                    <TableCell>Documento</TableCell>
                    <TableCell align="right">Debe</TableCell>
                    <TableCell align="right">Haber</TableCell>
                    <TableCell align="right">Saldo</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {rows.map(row => primaryRecordRow(row))}
            </TableBody>
        </Table>
    );
}

export default PrimaryRecordPanel;
